import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Cookie from 'common/services/util/-RFC.Cookie';
import * as Sentry from '@sentry/browser';

let _modal;
let _rootScope;
let _location;
let _Util;
let _JWT;
const _serviceDependencies = ['$modal', '$rootScope', '$location', 'Util', 'JWT'];

/**
 * @ngdoc service
 * @name services.ErrorHandler
 *
 * @description
 * Service for handling errors when requesting critial resources
 */

class ErrorHandler {

    constructor($modal, $rootScope, $location, Util, JWT) {

        _modal = $modal;
        _rootScope = $rootScope;
        _location = $location;
        _Util = Util;
        _JWT = JWT;

    }

    /**
     * @ngdoc function
     * @name services.ErrorHandler.handleError
     *
     * @description
     * Decide how to handle the error based on its type
     */
    handleError(errorResponse, errorLocation) {

        let errorReason;

        // do not show modal if password reset token is expired
        if (_Util.deepFind(errorResponse, 'data.error') && errorResponse.data.error === 'expired_token') {

            // check if on password reset page
            if (_location.path().indexOf('auth/reset') > -1) {

                return;

            }

        }

        if (_Util.deepFind(errorResponse, 'data.error')) {

            errorReason = errorResponse.data.error;

        } else if (_Util.deepFind(errorResponse, 'data.errors')) {

            errorReason = errorResponse.data.errors[0].detail;

        }

        // Show critical error modal for unhandled status codes

        this.openCriticalErrorModal(errorResponse);

        if (String(errorResponse.status) !== '401' && String(errorResponse.status) !== '403') {

            Sentry.withScope((scope) => {

                scope.setLevel('error');
                Sentry.captureMessage(`ErrorPage Opened with status code ${String(errorResponse.status)}`, undefined, errorResponse);

            });

        }

        const token = Cookie.get(CWCONFIG.cookie.token);
        let tokenSource = 'none';
        let tokenClient = 'none';

        if (token) {

            tokenSource = _JWT.getTokenPayload(token).src || 'none';
            tokenClient = _JWT.getTokenPayload(token).cid || 'none';

        }

        Mixpanel.send('ConnectWeb ErrorPage Open', {
            'Error Name': errorResponse.statusText,
            'Error Code': String(errorResponse.status),
            'API Resource': _Util.getRestResourceFromUrl(errorResponse.config.url),
            'Error Reason': errorReason,
            'Error Object Data': errorResponse.data,
            'Error Location': errorLocation,
            'Token Source': tokenSource,
            'Token Client': tokenClient,
        });

    }

    /**
     * @ngdoc function
     * @name services.ErrorHandler.openCriticalErrorModal
     *
     * @description
     * Open a Critical Error Modal
     * when a request for critial resource from the backend returns an error
     */
    openCriticalErrorModal(errorResponse) {

        _rootScope.State.loading = false;

        _modal.open({
            template: require('../../controllers/modals/critical-error/critical-error.html'),
            controller: 'CriticalError',
            backdrop: 'static',
            keyboard: false,
            windowClass: 'white-modal error-modal',
            resolve: {
                modalParams() {

                    return errorResponse;

                },
            },
        });

    }

    /**
     * @ngdoc function
     * @name services.ErrorHandler.reportError
     *
     * @description
     * Report a custom event via Mixpanel
     */
    reportEvent(resource, detail) {

        Mixpanel.send('ConnectWeb Report Event', {
            Resource: resource,
            Detail: detail,
        });

    }

}
_serviceDependencies.push(ErrorHandler);

angular.module('services')
    .service('ErrorHandler', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/common/services/ErrorHandler.js